import { createSlice } from "@reduxjs/toolkit";
import { getTermsAndConditionsDetailsAPI } from "../../services/getTermsAndConditionsDetails";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getTermsAndConditionsDetailsSlice = createSlice({
  name: "getTermsAndConditionsDetails",
  initialState,
  reducers: {
    getTermsAndConditionsDetailsInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    getTermsAndConditionsDetailsInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = "";
      state.message = "";
    },
    getTermsAndConditionsDetailsInfoFailure(state, action) {
      state.isLoading = false;
      state.message = "";
      state.error = action.payload;
      state.data = null;
    },
    getTermsAndConditionsDetailsInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getTermsAndConditionsDetailsHandler =
  (payload) => async (dispatch) => {
    try {
      dispatch(
        getTermsAndConditionsDetailsAction.getTermsAndConditionsDetailsInfo(
          payload,
        ),
      );
      const response = await getTermsAndConditionsDetailsAPI(payload);
      dispatch(
        getTermsAndConditionsDetailsAction.getTermsAndConditionsDetailsInfoSuccess(
          response,
        ),
      );
      return response;
    } catch (e) {
      const errMsg = e?.response?.data?.message || e?.message || String(e);
      dispatch(
        getTermsAndConditionsDetailsAction.getTermsAndConditionsDetailsInfoFailure(
          errMsg,
        ),
      );
      throw e;
    }
  };

export default getTermsAndConditionsDetailsSlice.reducer;
export const getTermsAndConditionsDetailsAction =
  getTermsAndConditionsDetailsSlice.actions;

